/*
this page is not used for now, as we don't have completed designs, but we will reactivate at a later date
when we move the distribution modal into its own page
 */

import React from "react";
import { connect } from "react-redux";
import { getShow, getYoutubeForShow } from "../../../action_managers/shows";
import { withRouter } from "react-router";
import ShowPageWrapper from "./show_page_wrapper";
import DistributionForm from "./distribution_form";
import { formValueSelector, submit } from "redux-form";
import { fetchDistributions, putDistributions } from "../../../action_managers/distributions";
import { useComponentDidMount } from "../../../lib/hook";

const ModalContent = props => {
  const showUUID = props.match.params.showUUID;
  var distribution = props.distributions[showUUID];

  return (
    <div className="distributions-modal-content">
      <DistributionForm
        validationErrors={props.validationErrors}
        initialValues={distribution}
        onSubmit={values => {
          props.putDistributions(showUUID, values);
        }}
        getDistributionFormValue={props.getDistributionFormValue}
        isPutting={props.isPutting}
        {...props}
      />
    </div>
  );
};
const ShowDistributionPage = props => {
  const showUUID = props.match.params.showUUID;
  useComponentDidMount(() => {
    props.fetchDistributions(showUUID);
    props.getShow(showUUID);
  });

  return (
    <ShowPageWrapper show={props.shows[showUUID]} title={"Distribution"}>
      <ModalContent {...props} />
    </ShowPageWrapper>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user.user,
    distributions: state.distributions.distributions,
    isLoading: state.distributions.isLoading,
    isPutting: state.distributions.isPutting,
    validationErrors: state.distributions.validationErrors,
    shows: state.shows.shows,
    getDistributionFormValue: key => {
      return formValueSelector("distribution-form")(state, key);
    },
  };
}

const mapDispatchToProps = {
  fetchDistributions,
  putDistributions,
  submitForm: () => {
    return submit("distribution-form");
  },

  getShow,
  getYoutubeForShow,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShowDistributionPage));
